import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Circle, CircleDto, CirclePrivacyType, ReviewViewModel } from '../models';

@Injectable()
export class CircleService {
  private readonly _componentName = 'CircleService';

  constructor(private http: HttpClient) { }

  circleGet(circleId: number) {
    return this.http.get<CircleDto>(`circle/${circleId}`);
  }

  async circleEnable(listingId: number) {    
    return await this.http.put<number>(`listing/${listingId}/access-control/enable`, true).toPromise();
  }

  async circleDisable(listingId: number) {
    return await this.http.put(`listing/${listingId}/access-control/disable`, false).toPromise();
  }

  async  togglePublicPrivate(circleId: number, privacy: CirclePrivacyType) {
    return await this.http.put<CirclePrivacyType>(`circle/${circleId}/privacy/`, privacy).toPromise();
  }

  async  remove(circleId: number) {
    return await this.http.delete(`circle/${circleId}/remove/`).toPromise();
  }

  public circleRequestDecide(circleId: number, circleMemberRequestId: number, accepted: boolean) {
    console.log(`${this._componentName}.circleRequestDecide`); 
    return this.http.put(`circle/${circleId}/request/${circleMemberRequestId}/decision`, accepted);
  }

  circleMemberDelete(circleId: number, userAccountId: number) {
    return this.http.delete(`circle/${circleId}/member/${userAccountId}`);
  }

  async circleMessageSet(circleId: number, message: string) {
    console.log('circle.service-> circleMessageSet: ' + circleId + ', message: ' + message);
    return await this.http.put(`circle/${circleId}/message`, `"${message}"`).toPromise();
  }

  async circleGetInfoForListing(listingId: number) {
    console.log(`${this._componentName}.circleGetInfoForListing listingId=`,listingId); 
    return await this.http.get<Circle>(`listing/${listingId}/access-control-info`).toPromise();
  }

  async circleRequestSubmit(circleId: number, messageToLandowner: string) {
    return this.http.post(`circle/${circleId}/request`, `"${messageToLandowner}"`);
  }

  circleRequestReviews(circleId: number, circleMemberRequestId: number) {
    return this.http.get<ReviewViewModel[]>(`circle/${circleId}/request/${circleMemberRequestId}/reviews`).toPromise();
  }

};
